module.exports = __webpack_public_path__ + "images/ab908e94289c927d22f5426b045ebffe.png";